import { GtmTracker } from '@wbk/analytics';

export const gtmTracker = new GtmTracker({
  gtmIds: process.env.VITE_PUBLIC_GOOGLE_TAG_MANAGER?.split(',') || [],
  log: process.env.VITE_PUBLIC_ENV !== 'production',
});
